import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
import GalleryGridFront from './layout/portfolio/GalleryGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

import Paragraph from './layout/Paragraph';
import ProcessThreeSteps from './layout/Process';

import ImageGridx1 from './layout/portfolio/ImageGridx1';
import ImageGridx3 from './layout/portfolio/ImageGridx3';

import GalleryGridx1 from './layout/portfolio/GalleryGridx1';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';
import VideoMockup from './layout/portfolio/VideoMockup';
import PenIcon from './asset/PenIcon';

import Front from './img/medibank/MB_Cover@2x.jpg';
import MBBackdrop from './img/medibank/medibank_feature@2x.jpg';

import MBProcess_1 from './img/medibank/MBProcess_cover@2x.jpg';
import MB_process_video from './img/medibank/Processexplained.mp4';

import MB_branding1 from './img/medibank/MBBranding1@2x.png';
import MB_branding2 from './img/medibank/MBBranding2@2x.png';
import MB_chat from './img/medibank/MBvision_chat.mp4';

// vision
import MBVision_1 from './img/medibank/MBVision_cover@2x.png';

// dentist
import MB_findDentists from './img/medibank/MB_findDentists@2x.png';

// provider portal
import ProviderPortal_1 from './img/medibank/MB_ProviderPortal_comp@2x.png';
import ProviderPortal_2 from './img/medibank/MB_ProviderPortal_1@2x.png';
import ProviderPortal_3 from './img/medibank/MB_ProviderPortal_2@2x.png';

// Summary
const companyInfo = {
  title: "Helping customers to get the most out of their cover",
  name: "Medibank",
  themeColor: "#E9696D",
  themeTextColor: "white",
  frontImage: Front,
  role: "Seniror product designer",
  fields: "Product design (UX/UI)",
  time: "June 2018 – Mar 2019",
  paragraph:"Medibank is a private health insurance provider. I contracted as a senior product designer to conceptualise the mobile app. I delivered features to help customers to get the most out of their cover and ease the claiming process."
}

// Responsibilities
const list = ['Translated business needs into actionable design plans.', 'Worked closely with design leadership to improve the creative process.', 'Collaborated with the user researcher to uplift usability during the design process.', 'Used prototyping as a mean to convey iterative and experimental ideas.', 'Managed communications between engineers, legal, and business stakeholders.']

// Who are Medibank?
const aboutMedibank ={
  summary: "ABOUT THE COMPANY",
  image: MBBackdrop,
  title: "Who are Medibank?",
  paragraph: "Medibank is Australia’s second-largest health insurance provider, offering ranges of digital products for their 3.5 million members and Metical practitioners. Medibank’s digital products aim to help members by fastening the process and communication around the customer experience.",
  textColor: "#ffffff",
  themeColor: "#6A173D",
}

// #1 - Talking about design process
const MBDesignProcess ={
  summary: "The design process",
  heading:"The gist was to make it work first, then make it look fantastic at the end.",
  paragraph: "Medibank has various experts – legal, marketing, customer service, and medical. Everyone's knowledge is important, but making UX decisions could be daunting compared to tech companies. I wanted to improve the communication in the team by guiding them to see the forest rather than the trees.",
  paragraph_2:"Based on this principle, all the screen design was initially created as a flow chart with rough sketches. Those early sketches helped us to focus on the goal and let the team use their expertise. (Rather than talking about temporary images!)",
  paragraph_3:"The beauty of <Make it work first> is that it allows autonomy to designers in aesthetics decisions. After the UX solution is outlined, the design team can spend hours thinking about anything beautiful - iconography, transition, typography, and colours. ",
  video: MB_process_video,
  caption_1: "People without design backgrounds find it hard to comprehend the rough ideas inside of the highly polished design. In contrast, these childlike sketches work better to communicate about the goal.",
  caption_2:"The Before/After!🎉 As you can see, the backbone is created in the rough sketch stage. After that, the clever details can be added with the design iteration."
}

// #2 - Talking about how we built each feature
const MBPrototyping ={
  video_1:MB_chat,
  summary: "Creating experiences",
  heading:"We knew insurance can be really complex by nature. Our mission was to make it easier with the power of design.",
  paragraph:"The 3.5 million members have various digital literacy. Our user could be a tech-savvy person with the latest smartphone or someone who uses an old computer. We knew insurance can be really complex by nature. However, if the design is easy, more people can use their cover well. – That was our goal.",
  paragraph_2:"Interactive prototyping was a crucial tool to make us close to this goal. As you can consider touch, gestures, and timing while designing, the outcome can be easily understood by anyone in the team. Moreover, we could easily use the prototype in the user testings.\n\nFrom conceptual to practical projects, I've created intuitive experiences with prototyping. It helped Medibank to release new features that look not only nice but also easy to use for everyone. ",
  caption: "Interactive prototype is a great way to visualise how people can use a feature."
}

// Vision
const MBVision ={
  image_1: MBVision_1,
  summary: "Mobile vision",
  heading: "Envisioned next generation of the Medibank mobile app",
  paragraph: "When the Medibank design team has reformed, there was a demand for a new vision. The stakeholders had a full of ideas in the wishlist, however, it wasn't easy to conceptualise all of them into one product. Excitingly, that became my first mission at Medibank.\n\nThe vision shows how the Medibank app can hold rich features to help customers. Thanks to interactive prototyping I could successfully envision how the different experiences can be merged together in one app. The outcome assisted Medibank to create a road map for the year.",
  themeColor: '#56A684',
  textColor: '#ffffff',
}

// Dentist
const MBDentist ={
  image_1: MB_findDentists,
  summary: "Book a dentist",
  heading: "Designed to help more members to get a free dental check-up",
  paragraph: "Many dental problems are preventable with regular visits to the dentist.  Based on this thought, Medibank partnered with select dentists to offer free dental check-ups. However, up to that point, there was no online booking on the Medibank app. The constraints of early API needed to be improved with experience design.\n\nTo make that happen, I collaborated with the user researchers to understand how people visit a dentist. After each user interview, we iterated the design. Thanks to all the efforts, we could turn the limitation into a viable experience. This feature has been released and successfully used by the customers.",
  caption:"The initial prototype helped us to validate our assumptions around finding and booking dentists with real users.",
  themeColor: '#ffffff',
}

// Provider portal
const MBProviderPortal ={
  image_1: ProviderPortal_1,
  image_2: ProviderPortal_2,
  image_3: ProviderPortal_3,
  summary: "Provider portal",
  heading: "Tailored for practice admins to manage anything around Medibank",
  paragraph: "The health providers are another consumer of Medibank's digital products. Compared to the members, they are oriented by totally different goals and interests to manage the clinics. Provider Portal was created to be an easy-to-use admin system for the practice managers.\n\nWith a deep understanding of how practice managers manage multiple doctors and inquiries, we created a simple solution that can easily used without the learning curve. ",
  themeColor: '#39447A',
  textColor: '#ffffff',
}

const metatag = {
  title: "Portfolio ✴︎ " + companyInfo.name,
  author: "Jinju Jang",
  url: "http://jinju.io/medibank",
  description: companyInfo.paragraph,
  image: "http://jinju.io" + Front
}

class PortfolioMedibank extends Component {
  render() {
    return (
      <div>
        {/*Meta data*/}
        <Helmet>
        <meta charSet="utf-8"/>
        <title>{metatag.title}</title>
        <meta name="author" content={metatag.author}/>
        <meta name="description" content={metatag.description}/>

        {/*-- Google / Search Engine Tags --*/}
        <meta itemprop="name" content={metatag.title}/>
        <meta itemprop="description" content={metatag.description}/>
        <meta itemprop="image" content={metatag.image}/>

        {/*-- Open Graph / Facebook --*/}
        <meta property="og:url" content={metatag.url}/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content={metatag.title} />
        <meta property="og:description" content={metatag.description}/>
        <meta property="og:image" content={metatag.image}/>

        {/*-- Twitter --*/}
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:title" content={metatag.title}/>
        <meta name="twitter:description" content={metatag.description}/>
        <meta name="twitter:image" content={metatag.image}/>
       </Helmet>
        <Navigation />
        {/*Front page*/}
        <GalleryGridFront title={companyInfo.title} first={Front} themeColor={companyInfo.themeColor}/>
        {/*Position summary*/}
        <ProjectInfo
          title={companyInfo.name}
          role={companyInfo.role}
          fields={companyInfo.fields}
          time={companyInfo.time}
          description={companyInfo.paragraph}
          dotPoints={list}/>

        {/*----- Who are medibank? ------*/}
        <ImageGridx1
          first={aboutMedibank.image}
          innerDescription={<BriefIcon summary={aboutMedibank.summary} titleIcon={<PenIcon color={aboutMedibank.textColor}/>}
          title={aboutMedibank.title}
          paragraph={aboutMedibank.paragraph} textColor={aboutMedibank.textColor}/>}themeColor={aboutMedibank.themeColor}
          showTriangle
        />

        {/*----- Design process ------*/}
        <Paragraph
          titleText={MBDesignProcess.summary}
          heading={MBDesignProcess.heading}
          paragraph={MBDesignProcess.paragraph + "\n\n" + MBDesignProcess.paragraph_2}
        />

        <GalleryGridx1
          first={MBProcess_1}
          caption={MBDesignProcess.caption_1}
        />

        <Paragraph
          paragraph={MBDesignProcess.paragraph_3} />

        <div className="col col-1">
          <div className="container">
            <VideoMockup
              video={MBDesignProcess.video}
              caption={MBDesignProcess.caption_2}/>
          </div>
        </div>

       {/*----- Prototyping ------*/}

       <GalleryGridx2
         first={MB_branding1}
         second={MB_branding2}
       />

        <Paragraph
          titleText={MBPrototyping.summary}
          heading={MBPrototyping.heading}
          paragraph={MBPrototyping.paragraph}
        />

        <div className="col col-1">
          <div className="container">
            <VideoMockup
              video={MBPrototyping.video_1}
              caption={MBPrototyping.caption}/>
          </div>
        </div>

        <Paragraph
          paragraph={MBPrototyping.paragraph_2}
        />

        {/*----- three points ------*/}
        <ProcessThreeSteps
          heading="Highlights"
          first={MBVision.summary}
          firstDetail={MBVision.heading}
          second={MBDentist.summary}
          secondDetail={MBDentist.heading}
          third={MBProviderPortal.summary}
          thirdDetail={MBProviderPortal.heading}
          />

        {/*----- Mobile vision ------*/}
        <ImageGridx1
          first={MBVision.image_1}
          innerDescription={<BriefIcon summary={MBVision.summary}
          title={MBVision.heading}
          paragraph={MBVision.paragraph} textColor={MBVision.textColor}/>}themeColor={MBVision.themeColor}
          showTriangle
        />

        {/*----- Book a dentist ------*/}
        <ImageGridx1
          first={MBDentist.image_1}
          innerDescription={<BriefIcon summary={MBDentist.summary}
          title={MBDentist.heading}
          paragraph={MBDentist.paragraph} textColor={MBDentist.textColor}/>}themeColor={MBDentist.themeColor}
          showTriangle
        />

        {/*----- Provider portal ------*/}
        <ImageGridx3
          first={MBProviderPortal.image_1}
          second={MBProviderPortal.image_2}
          third={MBProviderPortal.image_3}
          innerDescription={<BriefIcon summary={MBProviderPortal.summary}
          title={MBProviderPortal.heading}
          paragraph={MBProviderPortal.paragraph} textColor={MBProviderPortal.textColor}/>}
          themeColor={MBProviderPortal.themeColor}
          showTriangle
        />
      <NextUp
        previous="Sportsmate"
        previousURL="/sportsmate"
        next="Performance Leader"
        nextURL="/performanceLeader"
      />
      <WarpLarge />
      <Footer/>
    </div>
    );
  }
}

export default PortfolioMedibank;



// WEBPACK FOOTER //
// ./src/PortfolioMedibank.js